import React from 'react';
import { Tag } from 'antd';
import { ImportOutlined, ExportOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { transportDirectionShortKey, type TransportDirection } from '../transportDirection';

/** WP14: "Przychodzący" / "Wychodzący" marker of a truck; nothing for an unknown direction. */
const TransportDirectionTag: React.FC<{ direction?: TransportDirection | null }> = ({ direction }) => {
  const { t } = useTranslation(['transport']);
  if (!direction) return null;
  return (
    <Tag
      data-testid="transport-direction-tag"
      color={direction === 'INBOUND' ? 'geekblue' : 'green'}
      icon={direction === 'INBOUND' ? <ImportOutlined /> : <ExportOutlined />}
      style={{ marginInlineEnd: 0 }}
    >
      {t(transportDirectionShortKey(direction))}
    </Tag>
  );
};

export default TransportDirectionTag;
